"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var docDefinitions;
        (function (docDefinitions) {
            var createOrEdit;
            (function (createOrEdit) {
                function init() {
                    appn.select.init({
                        selector: 'select#iconsToDisplay',
                        isIconSelect: true
                    });
                }
                createOrEdit.init = init;
            })(createOrEdit = docDefinitions.createOrEdit || (docDefinitions.createOrEdit = {}));
        })(docDefinitions = views.docDefinitions || (views.docDefinitions = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
